import React, { Component, } from 'react';
import { connect } from 'react-redux';
import Toast from './sub_components/toast';
import Header from '../components/header';
import UserMenu from '../components/userMenu';
import * as authServices from '../services/authService';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import * as authUtil from "../util/auth.util";
class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uid: "",
            username: "",
            fullname: "",
            mobilenumber: "",
            whatsappnumber: "",
            dateofbirth: null,
            emailid:"",
            country:"",
            stat:"",
            city:"",
            showToast: false,
            toastMsg: "",
            toastType: ""
        };
    }
    componentDidMount() {
        let userData = localStorage.getItem("tokenData")
        userData = JSON.parse(userData)
        if(!(!!userData && !!userData.sub)){
            authUtil.logout(true);
        }
        let profData = localStorage.getItem("profData")
        if(!!profData)
        {
            profData = JSON.parse(profData)
            this.setState({ uid: userData.sub,
                username: profData.username,
                fullname: profData.name,
                mobilenumber: profData.mobile,
                whatsappnumber: profData.whatsappMobile,
            dateofbirth: null,
            emailid:profData.email,
            country:"",
            stat:"",
            city: profData.city,
            showToast: false,
            toastMsg: "",
            toastType: "" })
        }
        else{
            this.setState({ uid: userData.sub })
        }
        debugger
    }
    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }
    
    onDateTimeChange(name, e) {
        this.setState({ [name]: e._d })
    }
    
    async submitForm() {
        // if (!this.state.oldpasscode) {
        //     this.showToast("Please insert old password!", "error")
        //     return false
        // }

        // if (!this.state.passcode) {
        //     this.showToast("Please insert new password!", "error")
        //     return false
        // }

        // if (this.state.passcode.length < 6) {
        //     this.showToast("Password must have atlist 6 digit!", "error")
        //     return false
        // }

        // if (this.state.passcode !== "" && this.state.passcode !== this.state.repasscode) {
        //     return false
        // }
        let body = {
            "OldPassword": this.state.oldpasscode,
            "NewPassword": this.state.passcode,
            "ConfirmPassword": this.state.repasscode
        }
        await authServices.changePassword(body).then((res) => {
            if (res.isSuccess) {
                this.setState({ oldpasscode: "", passcode: "", repasscode: "" })
                this.showToast("Password changed successfully!", "success")
                this.props.history.push('/home')
            } else {
                this.showToast(res.exception.message, "error")
            }
        })
    }

    onChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value }, () => {
            // if (name === "passcode" && !!value) {
            //     if (value.match(/[0-9]/g)) {
            //         document.getElementById("digit").className = "success-text"
            //     } else {
            //         document.getElementById("digit").className = ""
            //     }

            //     if (value.match(/[a-zA-Z]/g)) {
            //         document.getElementById("scharacter").className = "success-text"
            //     } else {
            //         document.getElementById("scharacter").className = ""
            //     }

            //     if (value.length >= 8) {
            //         document.getElementById("minlength").className = "success-text"
            //     } else {
            //         document.getElementById("minlength").className = ""
            //     }

            //     if (value === this.state.oldpasscode) {
            //         document.getElementById("notold").className = "error-text d-block"
            //     } else {
            //         document.getElementById("notold").className = "error-text d-none"
            //     }

            //     if (value.toLowerCase().indexOf(this.state.uid.toLowerCase()) !== -1) {
            //         document.getElementById("notuser").className = "error-text d-block"
            //     } else {
            //         document.getElementById("notuser").className = "error-text d-none"
            //     }
            // }
        })
    }

    render() {
        return (
            <div className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) =>this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} />
                <div className="full-wrap">
                    <UserMenu history={this.props.history} />
                    <div className="col-center1 markets">
                        <div className="mar-top100">
                            <div className="sub_path center-box mt-2">
                                <p>User Profile</p>
                            </div>
                            <div className="allreport col3 ">
                                <div className="row mx-0 pt-3">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className="row mx-0">
                                            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                                                <div className="form-group">
                                                    <label htmlFor="text">User Name:</label>
                                                    <input type="text" value={this.state.username} name="username" id="username" onChange={(e) => { this.onChange(e) }} className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                                                <div className="form-group">
                                                    <label htmlFor="text">Full Name:</label>
                                                    <input type="text" value={this.state.fullname} name="fullname" id="fullname" onChange={(e) => { this.onChange(e) }} className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                                                <div className="form-group">
                                                    <label htmlFor="text">Mobile Number:</label>
                                                    <input type="text" value={this.state.mobilenumber} name="mobilenumber" id="mobilenumber" onChange={(e) => { this.onChange(e) }} className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                                                <div className="form-group">
                                                    <label htmlFor="text">Whatsapp Number:</label>
                                                    <input type="text" value={this.state.whatsappnumber} name="whatsappnumber" id="whatsappnumber" onChange={(e) => { this.onChange(e) }} className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                                                <div className="form-group">
                                                    <label htmlFor="text">Date of Birth:</label>
                                                    <Datetime
                                                        value={this.state.dateofbirth}
                                                        onChange={(e) => this.onDateTimeChange("dateofbirth", e)}
                                                        id="dateofbirth_datetime"
                                                        dateFormat={"DD/MM/YYYY"}
                                                        timeFormat={false}
                                                    />
                                                </div>
                                            </div>
                                            {/* <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                                                <div className="form-group">
                                                    <label htmlFor="text">Email ID:</label>
                                                    <input type="text" value={this.state.emailid} name="emailid" id="emailid" onChange={(e) => { this.onChange(e) }} className="form-control" />
                                                </div>
                                            </div> */}
                                            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                                                <div className="form-group">
                                                    <label htmlFor="text">Country:</label>
                                                    <input type="text" value={this.state.country} name="country" id="country" onChange={(e) => { this.onChange(e) }} className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                                                <div className="form-group">
                                                    <label htmlFor="text">State:</label>
                                                    <input type="text" value={this.state.stat} name="stat" id="stat" onChange={(e) => { this.onChange(e) }} className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                                                <div className="form-group">
                                                    <label htmlFor="text">City:</label>
                                                    <input type="text" value={this.state.city} name="city" id="city" onChange={(e) => { this.onChange(e) }} className="form-control" />
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="row mx-0">
                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 my-3 change-pass"><button onClick={(e) => { this.submitForm() }} className="btn place-bet-btn" disabled={this.state.passcode.match(/[0-9]/g) && this.state.passcode.match(/[a-zA-Z]/g) && this.state.passcode.length >= 8 && this.state.passcode !== this.state.oldpasscode && this.state.passcode.toLowerCase().indexOf(this.state.uid.toLowerCase()) === -1 && this.state.passcode === this.state.repasscode ? false : true}>Update</button></div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                </div>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Profile);